import { makeAutoObservable } from 'mobx';
import { validateBreak } from './validateBreak';

export class BreakData {
  priceToBreak = 0;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.priceToBreak = 0;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateBreak(this.priceToBreak);
    return result;
  };
  returnJson = () => {
    return {
      priceToBreak: this.priceToBreak,
    };
  };

  //specific methods
  setBreakPrice = (price) => {
    this.priceToBreak = price;
  };
}
